import { useState } from "react"

export const usePurchaseOrderList = () => {
    const [openCreate, setOpenCreate] = useState(false);

    return {
        openCreate,
        setOpenCreate,
    }
}